export class MeasurementSystemEvents {
	static measurementSystemChanged: string = "MeasurementSystemChanged";
}